import { sortBy } from 'lodash';
import { FinancialStatementPeriod } from 'common/types/financials';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import parseDatabaseValue from 'utilities/parseDatabaseValue';
import ReferenceGeneratorService, { MappingReferenceData, MODEL_TYPE_VALUE_SET } from '../services/reference-generator.service';

const reverseParser = ({
  cells,
  columns,
  allowEmptyValues,
  rowConfig,
  fieldAttributes,
}: {
  cells: Record<string, any>;
  columns: FinancialStatementPeriod[];
  allowEmptyValues: boolean;
  rowConfig: Record<string, any>[];
  fieldAttributes: Record<string, any>;
}) => {
  let tableColumns: FinancialStatementPeriod[] = [];

  const sortedColumns = sortBy([...columns], ['order']);
  const alphabet = alphabetGenerator([], sortedColumns.length);

  sortedColumns.forEach((column, columnIndex) => {
    const columnLegend = alphabet[columnIndex];
    const statementData = column.income_statement as any;

    // Collect all mapping references for this column
    const columnMappingReferences: any[] = [];

    // replace updated values
    rowConfig.forEach((cell, cellIndex) => {
      const key = columnLegend + (cellIndex + 1);
      const defaultValue = cell.defaultValue || null;
      const type = cell.dbType || null;
      const format = cell.format || null;
      const value = cells[key] ? cells[key].value : defaultValue;
      const { gridType } = cell;
      const decimalPlaces = fieldAttributes[cell.alias]?.decimal_places;

      if (cell.alias && cells[key] && statementData) {
        statementData[cell.alias] = parseDatabaseValue({
          type,
          value,
          format,
          allowEmptyValues,
          gridType,
          decimalPlaces,
        });

        // Extract mapping references from the cell if they exist
        const cellWithRefs = cells[key] as any;
        if (cellWithRefs.mappingReferences && cellWithRefs.mappingReferences.length) {
          columnMappingReferences.push(...cellWithRefs.mappingReferences);
        }
      }
    });

    // Attach mapping references to the statement data
    statementData.mapping_references = columnMappingReferences;

    const referenceGeneratorService = new ReferenceGeneratorService();
    const incomeStatementMappingReferences: MappingReferenceData[] = [];
    const balanceSheetMappingReferences: MappingReferenceData[] = [];

    columnMappingReferences.forEach(ref => {
      const modelType = referenceGeneratorService.getFieldModelType(ref.field_name);
      switch (modelType) {
        case MODEL_TYPE_VALUE_SET.INCOME_STATEMENT:
          incomeStatementMappingReferences.push(ref);
          break;
        case MODEL_TYPE_VALUE_SET.BALANCE_SHEET:
          balanceSheetMappingReferences.push(ref);
          break;
        default:
          break;
      }
    });

    // Attach mapping references to the statement data
    statementData.mapping_references = columnMappingReferences;

    if (column && column.income_statement && (column.income_statement as any).mapping_references) {
      // eslint-disable-next-line no-param-reassign
      (column.income_statement as any).mapping_references = incomeStatementMappingReferences;
    }

    if (column && column.balance_sheet && (column.balance_sheet as any).mapping_references) {
      // eslint-disable-next-line no-param-reassign
      (column.balance_sheet as any).mapping_references = balanceSheetMappingReferences;
    }

    tableColumns = [...tableColumns, column];
  });

  return tableColumns;
};

export default reverseParser;
